'use strict';
import * as $j_app$002eutils$002e$002dTauri$0024$002dOn$002dClose$002dBehaviour from "./app.utils.-Tauri$-On-Close-Behaviour.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2(\u03b4name$4, _$ordinal$4) {
  this.Lapp_utils_Tauri$OnCloseBehaviour$$anon$2__f_$name$2 = null;
  this.Lapp_utils_Tauri$OnCloseBehaviour$$anon$2__f__$ordinal$2 = 0;
  this.Lapp_utils_Tauri$OnCloseBehaviour$$anon$2__f_$name$2 = \u03b4name$4;
  this.Lapp_utils_Tauri$OnCloseBehaviour$$anon$2__f__$ordinal$2 = _$ordinal$4;
}
export { $c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2 as $c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2 };
$c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2.prototype = new $j_app$002eutils$002e$002dTauri$0024$002dOn$002dClose$002dBehaviour.$h_Lapp_utils_Tauri$OnCloseBehaviour();
$c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2.prototype.constructor = $c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2;
/** @constructor */
function $h_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2() {
}
export { $h_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2 as $h_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2 };
$h_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2.prototype = $c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2.prototype;
$c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2.prototype.productPrefix__T = (function() {
  return this.Lapp_utils_Tauri$OnCloseBehaviour$$anon$2__f_$name$2;
});
$c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2.prototype.toString__T = (function() {
  return this.Lapp_utils_Tauri$OnCloseBehaviour$$anon$2__f_$name$2;
});
$c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.Lapp_utils_Tauri$OnCloseBehaviour$$anon$2__f_$name$2);
});
$c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2, "app.utils.Tauri$OnCloseBehaviour$$anon$2", ({
  Lapp_utils_Tauri$OnCloseBehaviour$$anon$2: 1,
  Lapp_utils_Tauri$OnCloseBehaviour: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2 as $d_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2 };
//# sourceMappingURL=app.utils.-Tauri$-On-Close-Behaviour$$anon$2.js.map
